import * as React from 'react';
import { useMemo } from 'react';
import { useAssistanceContext } from '../../../document/pages/Assistance/AssistanceContext.tsx';

export const createKeywordRegex = (keywords: string[]) => {
    if (!keywords?.length) return null;
    return new RegExp(`(${keywords.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
};

export const countKeywordMatches = (text: string, keywords: string[]): Record<string, number> => {
    // returns { keyword: count } for each keyword that matches in the text

    if (!keywords?.length) return {};

    const result = {};
    keywords.forEach((keyword) => {
        const regex = createKeywordRegex([keyword]);
        const matches = text.match(regex);
        if (matches) {
            result[keyword] = matches.length;
        }
    });

    return result;
};

export const useKeywordCounts = (text: string, keywords: string[]): Record<string, number> =>
    useMemo(() => {
        return countKeywordMatches(text, keywords);
    }, [text, keywords]);

const HighlightText = ({ text, keywords }: { text: string; keywords: string[] }) => {
    const highlightedText = useMemo(() => {
        if (!keywords?.length) return text;

        const regex = createKeywordRegex(keywords);
        return text?.split(regex).map((part, index) =>
            keywords.some((keyword) => part.toLowerCase() === keyword.toLowerCase()) ? (
                <mark key={index} className="bg-[#c5ffed]/80">
                    {part}
                </mark>
            ) : (
                part
            )
        );
    }, [text, keywords]);

    return <div>{highlightedText}</div>;
};

export const useHighlightKeywords = () => {
    const { record } = useAssistanceContext();
    try {
        return JSON.parse(record?.channel?.highlightKeywordList) || [];
    } catch (error) {
        return [];
    }
};

export default HighlightText;
